import React from 'react';
import loadable from '@loadable/component';
import Slider from 'react-slick';

import leafFlutteringInWind from 'assets/images/leaf-fluttering-in-wind.png';
import sneezingFace from 'assets/images/sneezing-face.png';
import baby from 'assets/images/baby.png';
import dogFace from 'assets/images/dog-face.png';
import construction from 'assets/images/construction.png';
import woman from 'assets/images/woman.png';
import explodingHead from 'assets/images/exploding-head.png';

import performanceStats from '../../static-data/performanceStatsStatic';
import { FILTER_NAMES } from '../../../shared/enums';

const LazyImg = loadable(() => import('../common/LazyImg'));
const FadeIn = loadable(() => import('../common/FadeIn'));

const Icons = {
  BB: leafFlutteringInWind,
  BS: sneezingFace,
  CC: dogFace,
  RP: baby,
  HW: construction,
  MB: woman,
  OR: explodingHead,
};

const StatsItem = ({
  page, type, isBold, value, label,
}) => {
  const isCurrentClass = type.includes(page) ? ' list-stats--current' : '';
  const isBoldClass = isBold ? ' bold-text' : '';
  const hasNovalueClass = value.includes('N/A') ? 'list-stats--hidden' : '';
  const isCenteredClass = label.includes('N-UNDECANE') && value.includes('N/A')
    ? ' list-stats--hidden-center'
    : '';
  return (
    <li
      className={`${isCurrentClass}${isBoldClass}${hasNovalueClass}${isCenteredClass}`}
    >
      <span className='stats-item__label'>{`The ${FILTER_NAMES[page]}`}</span>
      {page === type
      && (label.includes('CADR') || label.includes('AMMONIA')) ? (
        <span className='list-stats--highlited'>{value}</span>
        ) : (
          value
        )}
    </li>
  );
};

const StatsList = ({ label, stats, type }) => (
  <ul className='stats-item__list'>
    {Object.keys(Icons).map(key => {
      const statsData = {
        page: key,
        label,
        type,
        ...stats[key],
      };
      return <StatsItem key={key} {...statsData} />;
    })}
  </ul>
);

const ProductPerformanceStats = ({ type }) => {
  const settings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    focusOnSelect: true,
    cssEase: 'ease-in-out',
    infinite: true,
    variableWidth: true,
  };

  return (
    <div
      className='performace-stats'
      style={{ '--primary-color': ' #F42C52', '--secondary-color': '#FFF2F5' }}
    >
      <div className='container container--md'>
        <div className='performace-stats__header'>
          <h2 className='performace-stats__title'>
            And includes nearly 1 lb of granular activated carbon specifically
            targeting pet smells.
          </h2>
          <div className='performace-stats__description'>
            <p>
              The Critter Cuddler was designed with one job in mind: to filter
              out all the funk, odors, allergy triggers and dander our pets may
              release while keeping your home’s air clear and fresh. In addition
              to a high performance H13 HEPA filter that effectively removes
              dander from the air, the Critter Cuddler also comes with a carbon
              insert that targets ammonia removal (goodbye, animal funk) and a
              prefilter to catch larger particulates and bits.
            </p>
            <p>
              {' '}
              See how the Critter Cuddler stacks up against common household
              VOCs, and how it compares to Mila’s other filters.
            </p>
          </div>
        </div>
        <div className='performace-stats__table'>
          <div className='performace-stats__col performace-stats__col--label'>
            <ul className='performace-stats__labels'>
              {performanceStats.map(({ label }) => (
                <li key={label}>
                  {label.includes('CADR') ? (
                    <>
                      {label}
                      {' '}
                      <small>(m3/hr)</small>
                    </>
                  ) : (
                    label
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className='performace-stats__col performace-stats__col--values stats-grid'>
            <div className='stats-grid__head'>
              {Object.keys(Icons).map(key => (
                <div
                  className={`stats-grid__column stats-item${
                    key === type ? ' stats-item--current' : ''
                  }`}
                >
                  <h3 className='stats-item__title'>
                    <FadeIn>
                      <LazyImg src={Icons[key]} alt={FILTER_NAMES[key]} />
                    </FadeIn>
                    {' '}
                    The
                    {' '}
                    {FILTER_NAMES[key]}
                  </h3>
                </div>
              ))}
            </div>
            <div className='stats-grid__body'>
              {performanceStats.map(statsItem => (
                <StatsList {...statsItem} type={type} key={statsItem.label} />
              ))}
            </div>
          </div>
        </div>
        {/* x-y cards slider */}
        {/* <Slider className='performace-stats__slider' {...settings}>
          {performanceStats.map(statsItem => (
            <div className='performace-stats__item' key={statsItem.label}>
              <div className='performace-stats__card'>
                <h3 className='performace-stats__card-title'>
                  {statsItem.label.includes('CADR') ? (
                    <>
                      {statsItem.label}
                      {' '}
                      <small>(m3/hr)</small>
                    </>
                  ) : (
                    statsItem.label
                  )}
                  <svg className='icon icon-info'>
                    <use xlinkHref='#icon-info' />
                  </svg>
                </h3>
                <StatsItem {...statsItem} type={type} />
              </div>
            </div>
          ))}
        </Slider> */}

        <Slider className='performace-stats__slider' {...settings}>
          {[
            ...Object.keys(Icons).filter(key => key === 'CC'),
            ...Object.keys(Icons).filter(key => key !== 'CC'),
          ].map(key => (
            <div className='performace-stats__item' key={key}>
              <div className='performace-stats__card'>
                <h3 className='performace-stats__card-title'>
                  {' '}
                  The
                  {' '}
                  {FILTER_NAMES[key]}
                  <svg className='icon icon-info'>
                    <use xlinkHref='#icon-info' />
                  </svg>
                </h3>
                <ul className='stats-item__list'>
                  {performanceStats.map(({ label, stats }) => {
                    const { value, isBold } = stats[key];
                    return (
                      <li
                        key={label}
                        className={`${isBold ? 'bold-text' : ''}${
                          key === type ? ' list-stats--current' : ''
                        }${value.includes('N/A') ? 'list-stats--hidden' : ''}${
                          label.includes('N-UNDECANE') && value.includes('N/A')
                            ? ' list-stats--hidden-center'
                            : ''
                        } `}
                      >
                        <span className='stats-item__label'>
                          {label.includes('CADR') ? (
                            <>
                              {label}
                              {' '}
                              <small>(m3/hr)</small>
                            </>
                          ) : (
                            label
                          )}
                        </span>
                        {key === type
                        && (label.includes('CADR')
                          || label.includes('AMMONIA')) ? (
                            <span className='list-stats--highlited'>{value}</span>
                          ) : (
                            value
                          )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ProductPerformanceStats;
